// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'admin/core/store';
import {
    Item,
    Translate,
} from '@plesk/ui-library';
import { DashboardItemContainer } from 'admin/dashboard/containers/items/Styles';
import CardHeader from 'admin/dashboard/components/CardHeader';
import StatusesList from 'common/components/StatusesList/StatusesList';
import { StatusType } from 'common/components/Status/Status';

export type ComputeResourceItemProps =
    ReturnType<typeof mapStateToProps>;

export const ComputeResourceItem: React.FC<ComputeResourceItemProps> = ({
    stats,
}) => (
    <DashboardItemContainer>
        <Item
            view="card"
            title={
                <CardHeader to={'/admin/compute_resources'}>
                    <Translate content="dashboard.cards.computeResources" params={{ total: stats.total }}/>
                </CardHeader>
            }
        >
            <StatusesList
                items={[
                    {
                        status: StatusType.SUCCESS,
                        labelKey: 'computeResource.statuses.active',
                        value: stats.status.active,
                    },
                    {
                        status: StatusType.FAILED,
                        labelKey: 'computeResource.statuses.failed',
                        value: stats.status.failed,
                    },
                    {
                        status: StatusType.UNAVAILABLE,
                        labelKey: 'computeResource.statuses.unavailable',
                        value: stats.status.unavailable,
                    },
                ]}
            />
        </Item>
    </DashboardItemContainer>
);

const mapStateToProps = (state: RootState) => ({
    stats: state.dashboard.data.compute_resources,
});

export default connect(mapStateToProps)(ComputeResourceItem);
